import { render } from "./Wholesales.vue?vue&type=template&id=37af0240"
import script from "./Wholesales.vue?vue&type=script&lang=js"
export * from "./Wholesales.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Wholesale/Wholesales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37af0240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37af0240', __exports__)) {
    api.reload('37af0240', __exports__)
  }
  
  module.hot.accept("./Wholesales.vue?vue&type=template&id=37af0240", () => {
    api.rerender('37af0240', render)
  })

}


export default __exports__